import React, { useState } from "react";
import PropTypes from "prop-types";
import withStyles from '@mui/styles/withStyles';
import { Drawer } from "@mui/material";
import styles from "./styles";
import AppSidebar from "../AppSidebar";
import Sidebar from "../Sidebar";

export function Dashboard(props) {
    const { classes, children } = props;
    const [isSidebarOpen, setSidebarOpen] = useState(false);

    return (
        <div className={classes.root}>
            <AppSidebar onOpenSidebar={() => setSidebarOpen(true)} />
            <Drawer
                anchor="left"
                classes={{ paper: classes.drawerPaper }}
                onClose={() => setSidebarOpen(false)}
                open={isSidebarOpen}
                variant={"temporary"}
                ModalProps={{
                    BackdropProps: {
                        sx: {
                            backgroundColor: 'rgba(0, 0, 0, 0.5)',
                        }
                    }
                }}
            >
                <Sidebar className={classes.sidebar} setOpen={(o) => setSidebarOpen(o)}/>
            </Drawer>
            <main className={classes.content}>
                <div className={classes.contentWrapper}>{children}</div>
            </main>
        </div>
    );
}

Dashboard.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    classes: PropTypes.object.isRequired,
    title: PropTypes.string,
};

export default withStyles(styles)(Dashboard);
